// extracted by mini-css-extract-plugin
module.exports = {"pictureRight":"PictureRight_pictureRight__2aLyr","doubleContent":"PictureRight_doubleContent__2QL_f"};